import { FileUp } from "lucide-react";

import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";
import { Spinner } from "@src/shared/components/ui/spinner";
import { pluralize } from "@src/shared/utils/strings";

export function ActiveUploadProcessingGroup({ count }: { count: number }) {
  if (count <= 0) return null;

  return (
    <li>
      <div className="overflow-hidden rounded-[12px] border border-border bg-background shadow-none">
        <HorizontalFlexbox
          alignItems="center"
          className="gap-[11px] bg-muted/35 px-3.5 py-3"
        >
          <div className="w-4 shrink-0" aria-hidden="true" />
          <div className="flex size-[30px] shrink-0 items-center justify-center rounded-[8px] bg-primary/10 text-primary">
            <FileUp className="size-[15px]" aria-hidden="true" />
          </div>
          <VerticalFlexbox className="min-w-0 flex-1">
            <span className="truncate text-[13.5px] font-semibold text-surface-foreground">
              Just now
            </span>
            <span className="mt-0.5 font-mono text-[10.5px] text-muted-foreground">
              {[pluralize(count, "file"), "processing"].join(" · ")}
            </span>
          </VerticalFlexbox>
        </HorizontalFlexbox>
        <HorizontalFlexbox
          alignItems="center"
          className="gap-2 border-t border-border px-4 py-3 text-[12.5px] text-muted-foreground"
        >
          <Spinner size="sm" className="text-primary" />
          <span>
            Reading {pluralize(count, "file")} and extracting care gaps...
          </span>
        </HorizontalFlexbox>
      </div>
    </li>
  );
}
